// extracted by mini-css-extract-plugin
export var hideEditor = "_iu-2";
export var infoIcon = "_iu-3";
export var label = "_iu-1";
export var labelContainer = "_iu-0";
export var readonlyText = "_iu-4";